import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { path } from 'ramda';
import { isEmpty } from 'lodash';

import ShapedBox from '../../common/ShapedBox';
import Breadcrumbs from '../../common/Breadcrumbs';
import { checkInUser, checkOutUser, getCurrentActivity, getUserCheckIn, updateActivityStatus } from '../../api/checkIn';
import { fetchWorker } from '../../api/employees';
import './style.css';
import { ACTIVITY_STATUS } from '../../reducers/checkIn';
import { durationToString } from '../../utils/date';


class UserCheckIn extends Component {
    componentDidMount() {
        const { userid } = this.props.match.params;
        this.props.loadWorker(userid);
        this.props.getCheckin(userid);
        this.props.getCurrentActivity(userid);

        window.scrollTo(0, 0);
    }

    render() {
        const { userid } = this.props.match.params;

        const worker = path(['employees', 'worker'], this.props);
        const workerFullname = worker ? `${worker.firstname} ${worker.lastname}` : '';

        const activeCheckIn = path(['checkIn', 'activeCheckin'], this.props);
        const checkInTime = activeCheckIn && activeCheckIn.started_at ? new moment.unix(activeCheckIn.started_at).format("MM/DD/YYYY hh:mm a") : '';

        const currentActivity = path(['checkIn', 'currentActivity'], this.props);
        const currentActivityStart = currentActivity ? moment.unix(currentActivity.started_at).format("hh:mm a") : 0;
        const duration = currentActivity ? currentActivity.duration : null;
        const timeSpent = !!duration ? durationToString(duration) : '0m';

        const userCheckIn = path(['checkIn', 'userCheckIn'], this.props);
        if (isEmpty(userCheckIn)) {
            /* Indicates user has not checked in yet. */
            this.props.checkInUser(userid);
        }

        return (
            <div>
                <Breadcrumbs
                    list={[
                        { url: '/pages/check-in', icon: 'perm_contact_calendar', name: 'Check In' },
                        { url: '/pages/check-in', icon: 'person', name: `${workerFullname}` },
                    ]}
                />
                <div className='card'>
                    <div className='card-header rounded-top'>Check in</div>
                    <div className='card-block'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='w-50'>{`Checked in: ${checkInTime}`}</div>
                            <button className='btn ui-btn text-uppercase' onClick={() => this.props.history.goBack()}>Back</button>
                        </div>
                        <br />
                        <div className='d-flex justify-content-between'>
                            {currentActivity && currentActivity.status ?
                                <div className='d-flex flex-column'>
                                    <ShapedBox className={`activity-status-box text-sm paused activity-status-${currentActivity.status.toLowerCase()}`}>
                                        <p className='text-default f-w-500 text-uppercase'>{currentActivity.status}</p>
                                        <div>{currentActivity.customer_name}</div>
                                        <div>{currentActivity.task_name}</div>
                                        <div>Activity: {currentActivity.type_name}</div>
                                        <p>Started: {currentActivityStart}</p>
                                        <div className='text-default f-w-500'>{timeSpent}</div>
                                    </ShapedBox>
                                    {currentActivity && currentActivity.status.toLowerCase() === 'active' ?
                                        <button className='btn ui-btn text-uppercase m-t-10'
                                            onClick={() => this.props.updateActivity(currentActivity.id, ACTIVITY_STATUS.PAUSE)}
                                        >Pause</button> : null}
                                    {currentActivity && currentActivity.status.toLowerCase() === 'paused' ?
                                        <button className='btn ui-btn text-uppercase m-t-10'
                                            onClick={() => this.props.updateActivity(currentActivity.id, ACTIVITY_STATUS.RESUME)}
                                        >Resume</button> : null}
                                    {currentActivity && currentActivity.status.toLowerCase() !== 'stopped' ?
                                        <button className='btn btn-danger ui-btn text-uppercase m-t-10'
                                            onClick={() => this.props.updateActivity(currentActivity.id, ACTIVITY_STATUS.STOP)}
                                        >Stop</button> : null}
                                </div>
                                :
                                <button className='btn btn-success ui-btn text-uppercase'
                                    onClick={() => this.props.history.push(`/pages/check-in/${userid}/customers`)}
                                >New Work</button>
                            }
                            <button
                                disabled={currentActivity && currentActivity.status && currentActivity.status.toLowerCase() !== 'stopped'}
                                className='btn btn-danger ui-btn text-uppercase h-50'
                                onClick={() => this.props.checkOutUser(userid)}
                            >Check Out</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadWorker: (workerId) => {
            fetchWorker(workerId)(dispatch);
        },
        checkInUser: (userId) => {
            checkInUser(userId)(dispatch);
        },
        checkOutUser: (userId) => {
            checkOutUser(userId)(dispatch);
        },
        getCheckin: (userId) => {
            getUserCheckIn(userId)(dispatch);
        },
        getCurrentActivity: (userId) => {
            getCurrentActivity(userId)(dispatch);
        },
        updateActivity: (activityId, status) => {
            updateActivityStatus(activityId, status)(dispatch);
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCheckIn);



// WEBPACK FOOTER //
// ./src/containers/CheckInMain/index.js